// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Button, { ButtonPresentationProps } from "@stoneage/MobiusOverrides/Button/Button";
import React, { useState } from "react";

interface Props {
    label: string;
    readOnly?: boolean;
    disabled?: boolean;
    tooltipText: string;
    width: number;
    onButtonClick?: () => void;
    extendedStyles?: ButtonPresentationProps;
}

export interface JettinAppButtonStyles {
    button?: ButtonPresentationProps;
}

export const jettinAppButtonStyles: JettinAppButtonStyles = {};

const JettinAppButton = ({ extendedStyles, label, readOnly, width, onButtonClick, tooltipText, disabled }: Props) => {
    const [styles] = useState(() => mergeToNew(jettinAppButtonStyles, extendedStyles));

    return (
        <Button
            {...{ fieldWidth: width }}
            showIcon={width === 100}
            {...styles.button}
            onClick={onButtonClick}
            sizeVariant={width === 100 ? "medium" : "small"}
            disabled={readOnly || disabled}
            title={tooltipText}
        >
            {label}
        </Button>
    );
};
export default JettinAppButton;
